// extracted by mini-css-extract-plugin
export default {"tableBody":"ComponentsTabPanel_tableBody__6lU7H","tableWrapper":"ComponentsTabPanel_tableWrapper__KTVv2","container":"ComponentsTabPanel_container__5aY1C"};